// ============== For Taxes ========================
export const GOT_ALL_TAXES = 'GOT_ALL_TAXES';

// ============== For Card ========================
export const POST_CARD_INFOR = 'POST_CARD_INFOR';